///Prescription element
import React from 'react';
import { useTranslation } from 'react-i18next';
import { formatFullname, getObjectWithJsonDataToFormValues } from '../../libraries/utils';
import config from '../../config';

import Icon from '../../libraries/icons';

export default function PrescriptionElement({ prescription, route, ...rest }){
  const { t, i18n } = useTranslation();

  const { professional, status, date } = getObjectWithJsonDataToFormValues(
    prescription,
    ['id', 'date', 'status', 'professional']
  );

  return (
    <div key={rest.key}
      className={"flex pb-4 " + (rest.className ? rest.className : "")}
      onClick={rest.onClick && rest.onClick}
    >
      <div>
        <Icon className={"bg-base-200 rounded-full p-2 h-12 w-12 mr-3 " + (status === config.PRESCRIPTIONS.STATUS.ACTIVE ? "text-success" : "text-gray-400")} name="clipboard_list" />
      </div>
      <div className="mr-auto">
        <p>{t("Realizado por")}</p>
        <h4 className={"mb-2 " + (status ? "text-primary" : "text-gray-600")}>{formatFullname(professional)}</h4>
        <div className={"badge uppercase " + (status ? "badge-success" : "badge-ghost text-gray-400")}>
          {status === config.PRESCRIPTIONS.STATUS.ACTIVE ? t("Activa") : t("Inactiva")}
        </div>
      </div>
      <small className="text-gray-400">{t("timeRemains", { date: new Date(date) }).replace(config.TRANSLATE.TIME_REMAINS, '')}</small>
    </div>
  )
}
